import * as axios from './axios';
import * as channels from './channels';
import * as messages from './messages';
import * as users from './users';

const PlatformAPI = {
  ...axios,
  ...channels,
  ...messages,
  ...users,
};

export default PlatformAPI;
